var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { TerminalsStatus } from "./TerminalsState";
import { TERMINALS_RESET_ACTION_TYPE, TERMINALS_GET_START_ACTION_TYPE, TERMINALS_GET_SUCCESS_ACTION_TYPE, TERMINALS_FETCH_START_ACTION_TYPE, TERMINALS_FETCH_SUCCESS_ACTION_TYPE, TERMINALS_ORDER_FETCH_START_ACTION_TYPE, TERMINALS_ORDER_FETCH_SUCCESS_ACTION_TYPE, TERMINALS_SAVE_START_ACTION_TYPE, TERMINALS_SAVE_SUCCESS_ACTION_TYPE, TERMINALS_ORDER_SAVE_START_ACTION_TYPE, TERMINALS_ORDER_SAVE_SUCCESS_ACTION_TYPE, TERMINALS_ORDER_COMPLETE_START_ACTION_TYPE, TERMINALS_ORDER_COMPLETE_SUCCESS_ACTION_TYPE, TERMINALS_ORDER_CANCEL_START_ACTION_TYPE, TERMINALS_ORDER_CANCEL_SUCCESS_ACTION_TYPE, TERMINALS_ORDER_DELETE_START_ACTION_TYPE, TERMINALS_ORDER_DELETE_SUCCESS_ACTION_TYPE, TERMINALS_CHECK_STATUS_START_ACTION_TYPE, TERMINALS_CHECK_STATUS_SUCCESS_ACTION_TYPE, TERMINALS_CHANGE_STATUS_ORDER_START_ACTION_TYPE, TERMINALS_CHANGE_STATUS_ORDER_SUCCESS_ACTION_TYPE, TERMINALS_ERROR_ACTION_TYPE, } from "../action/TerminalsActionsTypes";
var initialState = {
    status: TerminalsStatus.Initial,
    loading: false,
    order: undefined,
    orders: [],
    terminal: undefined,
    terminals: [],
    terminalStatus: undefined,
};
export var terminalsReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case TERMINALS_RESET_ACTION_TYPE:
            return __assign({}, initialState);
        case TERMINALS_GET_START_ACTION_TYPE:
            return __assign(__assign({}, state), { businessProfile: undefined, status: TerminalsStatus.GettingTerminal, loading: true });
        case TERMINALS_GET_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { terminal: action.payload.terminal, status: TerminalsStatus.GetTerminalSuccess, loading: false });
        case TERMINALS_FETCH_START_ACTION_TYPE:
            return __assign(__assign({}, state), { businessProfile: undefined, status: TerminalsStatus.FetchingTerminals, loading: true });
        case TERMINALS_FETCH_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { terminals: action.payload.terminals, status: TerminalsStatus.FetchTerminalsSuccess, loading: false });
        case TERMINALS_ORDER_FETCH_START_ACTION_TYPE:
            return __assign(__assign({}, state), { businessProfile: undefined, status: TerminalsStatus.FetchingTerminalsOrders, loading: true });
        case TERMINALS_ORDER_FETCH_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { orders: action.payload.orders, status: TerminalsStatus.FetchTerminalsOrdersSuccess, loading: false });
        case TERMINALS_ORDER_SAVE_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: TerminalsStatus.SavingTerminalOrder, loading: true });
        case TERMINALS_ORDER_SAVE_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { status: TerminalsStatus.SaveTerminalOrderSuccess, order: action.payload.order, loading: false });
        case TERMINALS_CHANGE_STATUS_ORDER_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: TerminalsStatus.ChangingStatusOrders, loading: true });
        case TERMINALS_CHANGE_STATUS_ORDER_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { status: TerminalsStatus.ChangeStatusOrdersSuccess, order: action.payload.order, loading: false });
        case TERMINALS_ORDER_COMPLETE_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: TerminalsStatus.CompletingTerminalOrder, loading: true });
        case TERMINALS_ORDER_COMPLETE_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { status: TerminalsStatus.CompleteTerminalOrderSuccess, order: action.payload.order, loading: false });
        case TERMINALS_ORDER_CANCEL_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: TerminalsStatus.CancelingTerminalOrder, loading: true });
        case TERMINALS_ORDER_CANCEL_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { status: TerminalsStatus.CancelTerminalOrderSuccess, loading: false });
        case TERMINALS_ORDER_DELETE_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: TerminalsStatus.DeletingTerminalOrder, loading: true });
        case TERMINALS_ORDER_DELETE_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { status: TerminalsStatus.DeleteTerminalOrderSuccess, loading: false });
        case TERMINALS_SAVE_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: TerminalsStatus.SavingTerminal, loading: true });
        case TERMINALS_SAVE_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { status: TerminalsStatus.SaveTerminalSuccess, loading: false });
        case TERMINALS_CHECK_STATUS_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: TerminalsStatus.CheckingStatus, loading: true });
        case TERMINALS_CHECK_STATUS_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { status: TerminalsStatus.CheckStatusSuccess, terminalStatus: __assign({}, action.payload.terminalStatus), loading: false });
        case TERMINALS_ERROR_ACTION_TYPE:
            return __assign(__assign({}, state), { status: TerminalsStatus.Error, loading: false });
        default:
            return state;
    }
};
export default terminalsReducer;
